// Builds a upi://pay intent link for a plain client-generated UPI QR (no gateway API,
// no order id) — staff reconciles the payment manually after the customer shares a
// screenshot. Shared by the customer portal's Payments page and plan-renewal flow.
export function buildUpiLink(config, amount, note) {
  if (!config?.upiId) return null;
  return `upi://pay?pa=${config.upiId}&pn=${encodeURIComponent(config.upiName || 'AngelNet')}&am=${amount}&cu=INR&tn=${encodeURIComponent(note)}`;
}

// UPI QR entries a customer should see: their CableTV entity's own, else the ones with no
// entity. Mirrors backend utils/paymentLink.js upiEntriesFor.
export function upiEntriesFor(entries, entityCode) {
  const entity = (String(entityCode || '').toUpperCase().match(/[A-Z]+\d+/) || [''])[0];
  const list = entries || [];
  const own = entity ? list.filter(e => e.entity === entity) : [];
  return own.length ? own : list.filter(e => !e.entity);
}
